define("shared/utils/plans-data/highlights-map", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  /**
   * @module Utils
   */

  /**
   * @class highlightsMapUtil
   * @extends Utils
   */

  /**
   * Stores highlights in callback functions accessible by plan type
   *
   * @method highlightsMap
   * @param {Service} intl
   * @param {Service} locale
   *
   * @returns {Record<PlanType, Highlights} Highlights per plan type
   */

  const highlightsMap = (intl, locale) => ({
    free: plan => ({
      highlights: [intl.t('shared_phrases.social_sets.count', {
        count: plan.numberOfSocialSets
      }), intl.t('shared_phrases.users.count', {
        count: plan.numberOfUsers
      }), intl.t('plans.highlight_mappings.posts_per_month', {
        count: plan.numberOfPosts
      }), intl.t('plans.free.highlights.highlight_4'), intl.t('plans.free.highlights.highlight_5')],
      autoTrialHighlights: {
        keyFeatures: [intl.t('authorization.sign_up_trial.posts_per_month_unstyled', {
          count: plan.numberOfPosts
        }), intl.t('plans.auto_trial.end_trial.limited_analytics_3_months'), intl.t('plans.auto_trial.end_trial.linkinbio_with_branding')],
        loseAccess: [intl.t('plans.auto_trial.end_trial.reels_and_stories'), intl.t('plans.auto_trial.end_trial.bttp'), intl.t('plans.auto_trial.end_trial.ai_tools')]
      }
    }),
    basics: plan => ({
      highlights: [intl.t('shared_phrases.social_sets.count', {
        count: plan.numberOfSocialSets
      }), intl.t('plans.highlight_mappings.posts_per_month', {
        count: plan.numberOfPosts
      }), intl.t('plans.basics.highlights.highlight_4'), intl.t('plans.highlight_mappings.limited_tags', {
        count: plan.numberOfCollectTags
      }), intl.t('plans.basics.highlights.highlight_5'), intl.t('plans.highlight_mappings.limited_hashtag_suggestions', {
        count: plan.numberOfHashtagSearches
      })],
      reactivationHighlights: [intl.t('plans.highlight_mappings.multi_photo'), intl.t('plans.highlight_mappings.tagging'), intl.t('plans.highlight_mappings.limited_tags', {
        count: plan.numberOfCollectTags
      }), intl.t('plans.highlight_mappings.limited_hashtag_suggestions', {
        count: plan.numberOfHashtagSearches
      })]
    }),
    starter: plan => ({
      highlights: [intl.t('shared_phrases.social_sets.count', {
        count: plan.numberOfSocialSets
      }), intl.t('shared_phrases.users.count', {
        count: plan.numberOfUsers
      }), intl.t('plans.highlight_mappings.posts_per_month', {
        count: plan.numberOfPosts
      }), intl.t('shared_phrases.schedule_stories'), intl.t('plans.highlight_mappings.video_uploads', {
        amount: plan.videoSizeLimit
      }), intl.t('plans.starter.highlights.highlight_6'), intl.t('shared_phrases.first_comment'), intl.t('shared_phrases.hashtag_suggestions'), intl.t('shared_phrases.multi_photo_auto_publish'), intl.t('plans.highlight_mappings.auto_publish_reels'), intl.t('plans.linkin_bio.generic')],
      autoTrialHighlights: {
        keyFeatures: [intl.t('authorization.sign_up_trial.posts_per_month_unstyled', {
          count: plan.numberOfPosts
        }), intl.t('plans.auto_trial.end_trial.limited_analytics_3_months'), intl.t('plans.auto_trial.end_trial.custom_linkinbio'), intl.t('plans.auto_trial.end_trial.collab_tools')]
      },
      migrationHighlights: [intl.t('shared_phrases.one_social_set'), intl.t('plans.highlight_mappings.posts_per_profile', {
        count: plan.numberOfPosts
      }), intl.t('shared_phrases.users.count', {
        count: plan.numberOfUsers
      }), intl.t('plans.migrate.new.starter.feature_4')],
      reactivationHighlights: [intl.t('plans.reactivation_highlights.reels_autopublish'), intl.t('plans.reactivation_highlights.multi_photo_autopublish'), intl.t('plans.reactivation_highlights.stories_schedule'), intl.t('plans.highlight_mappings.hashtag_suggestions'), intl.t('plans.highlight_mappings.bttp'), intl.t('plans.reactivation_highlights.tagging')],
      trialOptInHighlights: {
        featuresHeader: intl.t('authorization.sign_up_trial.starter.features_header'),
        includes: [intl.t('plans.card.social_set', {
          count: plan.numberOfSocialSets
        }), intl.t('shared_phrases.users.count', {
          count: plan.numberOfUsers
        })],
        keyFeatures: [intl.t('authorization.sign_up_trial.starter.list.stories_schedule'), intl.t('authorization.sign_up_trial.starter.list.reels_autopublish'), intl.t('authorization.sign_up_trial.starter.list.multi_autopublish'), intl.t('authorization.sign_up_trial.starter.list.bttp'), intl.t('authorization.sign_up_trial.starter.list.unlimited_hashtags', {
          count: plan.hasLimitedHashtagSearches ? plan.numberOfHashtagSearches : intl.t('plans.feature_mappings.unlimited')
        }), intl.t('authorization.sign_up_trial.starter.list.linkinbio'), intl.t('authorization.sign_up_trial.starter.list.analytics')],
        mobile: {
          includes: [intl.t('shared_phrases.social_sets.count', {
            count: plan.numberOfSocialSets
          }), intl.t('authorization.sign_up_trial.posts_per_month_unstyled', {
            count: plan.numberOfPosts
          }), intl.t('shared_phrases.users.count', {
            count: plan.numberOfUsers
          })]
        }
      },
      onboardingTrialOptInHighlights: {
        featuresHeader: intl.t('authorization.sign_up_trial.key_features'),
        keyFeatures: [intl.t('authorization.sign_up_trial.posts_per_month', {
          count: plan.numberOfPosts
        }), intl.t('authorization.sign_up_trial.starter.key_features.analytics'), intl.t('authorization.sign_up_trial.ai_credits_per_month', {
          count: plan.numberOfAiCredits
        }), intl.t('authorization.sign_up_trial.collab')],
        lostFeatures: [intl.t('onboarding.sourceless_trial.end_trial.what_you_lose.auto_publish'), intl.t('onboarding.sourceless_trial.end_trial.what_you_lose.bttp'), intl.t('onboarding.sourceless_trial.end_trial.what_you_lose.caption_writer'), intl.t('onboarding.sourceless_trial.end_trial.what_you_lose.hashtag')]
      }
    }),
    linkinbio: () => ({
      reactivationHighlights: [intl.t('plans.reactivation_highlights.linkinbio.utm'), intl.t('plans.reactivation_highlights.linkinbio.analytics'), intl.t('plans.reactivation_highlights.linkinbio.seo'), intl.t('plans.reactivation_highlights.linkinbio.no_branding')]
    }),
    creator: plan => ({
      highlights: [intl.t('shared_phrases.social_sets.count', {
        count: plan.numberOfSocialSets
      }), intl.t('shared_phrases.users.count', {
        count: plan.numberOfUsers
      }), intl.t('plans.highlight_mappings.posts_per_month', {
        count: plan.numberOfPosts
      }), intl.t('shared_words.partnerships'), intl.t('shared_words.brand_campaigns'), intl.t('shared_words.media_kit'), intl.t('plans.highlight_mappings.linkinbio_standard'), intl.t('plans.highlight_mappings.bttp')],
      migrationHighlights: [intl.t('shared_phrases.one_social_set'), intl.t('plans.highlight_mappings.posts_per_profile', {
        count: plan.numberOfPosts
      }), intl.t('shared_phrases.users.count', {
        count: plan.numberOfUsers
      }), intl.t('plans.migrate.new.starter.feature_4')],
      reactivationHighlights: [intl.t('plans.media_kit'), intl.t('shared_words.campaigns'), intl.t('plans.highlight_mappings.bttp'), intl.t('plans.highlight_mappings.linkinbio_standard')],
      trialOptInHighlights: {
        featuresHeader: intl.t('authorization.sign_up_trial.starter.features_header'),
        includes: [intl.t('authorization.sign_up_trial.posts_per_month', {
          count: plan.numberOfPosts
        }), intl.t('shared_phrases.users.count', {
          count: plan.numberOfUsers
        })],
        keyFeatures: [intl.t('authorization.sign_up_trial.creator.list.custom_media_kit'), intl.t('authorization.sign_up_trial.creator.list.brand_campaign'), intl.t('authorization.sign_up_trial.creator.list.linkinbio'), intl.t('authorization.sign_up_trial.creator.list.bttp'), intl.t('authorization.sign_up_trial.creator.list.analytics')],
        mobile: {
          includes: [intl.t('shared_phrases.social_sets.count', {
            count: plan.numberOfSocialSets
          }), intl.t('authorization.sign_up_trial.posts_per_month_unstyled', {
            count: plan.numberOfPosts
          }), intl.t('shared_phrases.users.count', {
            count: plan.numberOfUsers
          })]
        }
      },
      onboardingTrialOptInHighlights: {
        featuresHeader: intl.t('authorization.sign_up_trial.key_features'),
        keyFeatures: [intl.t('authorization.sign_up_trial.posts_per_month', {
          count: plan.numberOfPosts
        }), intl.t('authorization.sign_up_trial.creator.key_features.analytics'), intl.t('authorization.sign_up_trial.linkinbio_feature'), intl.t('authorization.sign_up_trial.collab')]
      }
    }),
    growth: plan => ({
      highlights: [intl.t('plans.highlight_mappings.social_sets_extra', {
        count: plan.numberOfSocialSets,
        amount: locale.formatCurrency(plan.additionalSocialSetCosts.monthly.dollars)?.replace('.00', '')
      }), intl.t('plans.highlight_mappings.users_with_extra', {
        count: plan.numberOfUsers,
        amount: locale.formatCurrency(plan.additionalUserCosts.monthly.dollars)?.replace('.00', '')
      }), intl.t('plans.highlight_mappings.posts_per_month', {
        count: plan.numberOfPosts
      }), intl.t('shared_phrases.schedule_stories'), intl.t('shared_phrases.linkinbio_generic'), intl.t('plans.growth.highlights.highlight_6'), intl.t('shared_phrases.first_comment'), intl.t('plans.growth.highlights.highlight_8'), intl.t('shared_phrases.multi_photo_auto_publish'), intl.t('shared_phrases.instagram_product_tags')],
      autoTrialHighlights: {
        keyFeatures: [intl.t('authorization.sign_up_trial.posts_per_month_unstyled', {
          count: plan.numberOfPosts
        }), intl.t('plans.auto_trial.end_trial.full_analytics'), intl.t('plans.auto_trial.end_trial.custom_linkinbio'), intl.t('plans.auto_trial.end_trial.collab_tools'), intl.t('plans.auto_trial.end_trial.team_and_brand_management')]
      },
      migrationHighlights: [intl.t('shared_phrases.social_sets.count', {
        count: plan.numberOfSocialSets
      }), intl.t('plans.highlight_mappings.posts_per_profile', {
        count: plan.numberOfPosts
      }), intl.t('plans.highlight_mappings.users_with_extra', {
        count: plan.numberOfUsers,
        amount: locale.formatCurrency(plan.additionalUserCosts.monthly.dollars)?.replace('.00', '')
      })],
      reactivationHighlights: [intl.t('plans.reactivation_highlights.reels_autopublish'), intl.t('plans.reactivation_highlights.multi_photo_autopublish'), intl.t('plans.reactivation_highlights.stories_schedule'), intl.t('plans.highlight_mappings.bttp'), intl.t('plans.reactivation_highlights.more_analytics'), intl.t('plans.reactivation_highlights.team_management')],
      trialOptInHighlights: {
        featuresHeader: intl.t('authorization.sign_up_trial.growth.features_header'),
        includes: [intl.t('plans.card.social_set', {
          count: plan.numberOfSocialSets
        }), intl.t('shared_phrases.users.count', {
          count: plan.numberOfUsers
        })],
        keyFeatures: [intl.t('authorization.sign_up_trial.growth.list.analytics'), intl.t('authorization.sign_up_trial.growth.list.linkinbio'), intl.t('authorization.sign_up_trial.growth.list.instagram_tagging'), intl.t('authorization.sign_up_trial.growth.list.collect'), intl.t('authorization.sign_up_trial.growth.list.brand_management')],
        mobile: {
          includes: [intl.t('shared_phrases.social_sets.count', {
            count: plan.numberOfSocialSets
          }), intl.t('authorization.sign_up_trial.posts_per_month_unstyled', {
            count: plan.numberOfPosts
          }), intl.t('shared_phrases.users.count', {
            count: plan.numberOfUsers
          })]
        }
      },
      autoTrialActivationHighlights: {
        keyFeatures: [intl.t('shared_phrases.social_sets.count', {
          count: plan.numberOfSocialSets
        }), intl.t('shared_phrases.users.count', {
          count: plan.numberOfUsers
        }), intl.t('plans.feature_highlights.posts_per_month', {
          count: plan.numberOfPosts
        }), intl.t('plans.feature_highlights.analytics_trial_activation'), intl.t('plans.feature_highlights.reels'), intl.t('authorization.sign_up_trial.growth.list.instagram_tagging'), intl.t('account.downgrade.linkinbio_without_branding'), intl.t('plans.feature_highlights.instagram_and_tiktok')]
      },
      onboardingTrialOptInHighlights: {
        featuresHeader: intl.t('authorization.sign_up_trial.key_features'),
        keyFeatures: [intl.t('authorization.sign_up_trial.posts_per_month', {
          count: plan.numberOfPosts
        }), intl.t('authorization.sign_up_trial.growth.key_features.analytics'), intl.t('authorization.sign_up_trial.ai_credits_per_month', {
          count: plan.numberOfAiCredits
        }), intl.t('authorization.sign_up_trial.collab'), intl.t('authorization.sign_up_trial.growth.key_features.brand_management')],
        lostFeatures: [intl.t('onboarding.sourceless_trial.end_trial.what_you_lose.auto_publish'), intl.t('onboarding.sourceless_trial.end_trial.what_you_lose.bttp'), intl.t('onboarding.sourceless_trial.end_trial.what_you_lose.caption_writer'), intl.t('onboarding.sourceless_trial.end_trial.what_you_lose.hashtag')]
      },
      sourcelessTrialConfirmationHighlights: {
        keyFeatures: [{
          text: intl.t('onboarding.sourceless_trial.growth.auto_publish'),
          icon: 'instant'
        }, {
          text: intl.t('onboarding.sourceless_trial.growth.caption_writer'),
          icon: 'ai'
        }, {
          text: intl.t('onboarding.sourceless_trial.growth.ai_credits'),
          icon: 'credit'
        }, {
          text: intl.t('onboarding.sourceless_trial.growth.bttp'),
          icon: 'bttp'
        }]
      }
    }),
    advanced: plan => ({
      highlights: [intl.t('plans.highlight_mappings.social_sets_extra', {
        count: plan.numberOfSocialSets,
        amount: locale.formatCurrency(plan.additionalSocialSetCosts.monthly.dollars)?.replace('.00', '')
      }), intl.t('plans.highlight_mappings.users_with_extra', {
        count: plan.numberOfUsers,
        amount: locale.formatCurrency(plan.additionalUserCosts.monthly.dollars)?.replace('.00', '')
      }), intl.t('shared_phrases.unlimited_posts'), intl.t('shared_phrases.schedule_stories'), intl.t('shared_phrases.linkinbio_generic'), intl.t('plans.advanced.highlights.highlight_6'), intl.t('shared_phrases.first_comment'), intl.t('plans.advanced.highlights.highlight_8')],
      migrationHighlights: [intl.t('plans.advanced.highlights.highlight_1'), intl.t('shared_phrases.unlimited_posts'), intl.t('plans.highlight_mappings.users_with_extra', {
        count: plan.numberOfUsers,
        amount: locale.formatCurrency(plan.additionalUserCosts.monthly.dollars)?.replace('.00', '')
      })],
      reactivationHighlights: [intl.t('plans.reactivation_highlights.reels_autopublish'), intl.t('plans.reactivation_highlights.multi_photo_autopublish'), intl.t('plans.reactivation_highlights.stories_schedule'), intl.t('plans.highlight_mappings.bttp'), intl.t('plans.reactivation_highlights.more_analytics'), intl.t('plans.reactivation_highlights.team_management')],
      trialOptInHighlights: {
        featuresHeader: intl.t('authorization.sign_up_trial.advanced.features_header'),
        includes: [intl.t('plans.card.social_set', {
          count: plan.numberOfSocialSets
        }), intl.t('shared_phrases.users.count', {
          count: plan.numberOfUsers
        })],
        keyFeatures: [intl.t('authorization.sign_up_trial.advanced.list.live_chat')]
      },
      onboardingTrialOptInHighlights: {
        featuresHeader: intl.t('authorization.sign_up_trial.key_features'),
        keyFeatures: [intl.t('authorization.sign_up_trial.advanced.unlimited_posts'), intl.t('authorization.sign_up_trial.advanced.key_features.analytics'), intl.t('authorization.sign_up_trial.ai_credits_per_month', {
          count: plan.numberOfAiCredits
        }), intl.t('authorization.sign_up_trial.collab'), intl.t('authorization.sign_up_trial.advanced.key_features.brand_management'), intl.t('authorization.sign_up_trial.advanced.key_features.live_chat')]
      }
    }),
    enterprise: () => ({
      highlights: [intl.t('plans.highlight_mappings.social_sets_extra', {
        count: 'custom',
        amount: ''
      }), intl.t('plans.highlight_mappings.users_with_extra', {
        count: 'custom',
        amount: ''
      }), intl.t('shared_phrases.unlimited_posts'), intl.t('shared_phrases.schedule_stories'), intl.t('shared_phrases.linkinbio_generic'), intl.t('plans.advanced.highlights.highlight_6'), intl.t('shared_phrases.first_comment'), intl.t('plans.advanced.highlights.highlight_8')],
      migrationHighlights: [intl.t('plans.advanced.highlights.highlight_1'), intl.t('shared_phrases.unlimited_posts'), intl.t('plans.highlight_mappings.users_with_extra', {
        count: 'custom',
        amount: '-'
      })],
      reactivationHighlights: [intl.t('plans.reactivation_highlights.reels_autopublish'), intl.t('plans.reactivation_highlights.multi_photo_autopublish'), intl.t('plans.reactivation_highlights.stories_schedule'), intl.t('plans.highlight_mappings.bttp'), intl.t('plans.reactivation_highlights.more_analytics'), intl.t('plans.reactivation_highlights.team_management')],
      trialOptInHighlights: {
        featuresHeader: intl.t('authorization.sign_up_trial.advanced.features_header'),
        includes: [intl.t('plans.card.social_set', {
          count: 'custom'
        }), intl.t('shared_phrases.users.count', {
          count: 'custom'
        })],
        keyFeatures: [intl.t('authorization.sign_up_trial.advanced.list.live_chat')]
      },
      onboardingTrialOptInHighlights: {
        featuresHeader: intl.t('authorization.sign_up_trial.key_features'),
        keyFeatures: [intl.t('authorization.sign_up_trial.enterprise.unlimited_posts'), intl.t('authorization.sign_up_trial.advanced.key_features.analytics'), intl.t('authorization.sign_up_trial.enterprise.ai_credits'), intl.t('authorization.sign_up_trial.linkinbio_feature'), intl.t('authorization.sign_up_trial.collab'), intl.t('authorization.sign_up_trial.advanced.key_features.brand_management'), intl.t('authorization.sign_up_trial.advanced.key_features.live_chat')],
        lostFeatures: [intl.t('onboarding.sourceless_trial.end_trial.what_you_lose.auto_publish'), intl.t('onboarding.sourceless_trial.end_trial.what_you_lose.bttp'), intl.t('onboarding.sourceless_trial.end_trial.what_you_lose.caption_writer'), intl.t('onboarding.sourceless_trial.end_trial.what_you_lose.hashtag')]
      }
    }),
    // eslint-disable-next-line @latermedia/later-linting/avoid-numerals-in-name
    starter202506: plan => ({
      highlights: [intl.t('shared_phrases.social_sets.count', {
        count: plan.numberOfSocialSets
      }), intl.t('shared_phrases.users.count', {
        count: plan.numberOfUsers
      }), intl.t('plans.highlight_mappings.posts_per_month', {
        count: plan.numberOfPosts
      }), intl.t('shared_phrases.schedule_stories'), intl.t('plans.highlight_mappings.video_uploads', {
        amount: plan.videoSizeLimit
      }), intl.t('plans.starter.highlights.highlight_6'), intl.t('shared_phrases.first_comment'), intl.t('shared_phrases.hashtag_suggestions'), intl.t('shared_phrases.multi_photo_auto_publish'), intl.t('plans.highlight_mappings.auto_publish_reels'), intl.t('plans.linkin_bio.generic')],
      autoTrialHighlights: {
        keyFeatures: [intl.t('authorization.sign_up_trial.posts_per_month_unstyled', {
          count: plan.numberOfPosts
        }), intl.t('plans.auto_trial.end_trial.limited_analytics_3_months'), intl.t('plans.auto_trial.end_trial.custom_linkinbio'), intl.t('plans.auto_trial.end_trial.collab_tools')]
      },
      migrationHighlights: [intl.t('shared_phrases.one_social_set'), intl.t('plans.highlight_mappings.posts_per_profile', {
        count: plan.numberOfPosts
      }), intl.t('shared_phrases.users.count', {
        count: plan.numberOfUsers
      }), intl.t('plans.migrate.new.starter.feature_4')],
      reactivationHighlights: [intl.t('plans.reactivation_highlights.reels_autopublish'), intl.t('plans.reactivation_highlights.multi_photo_autopublish'), intl.t('plans.reactivation_highlights.stories_schedule'), intl.t('plans.highlight_mappings.hashtag_suggestions'), intl.t('plans.highlight_mappings.bttp'), intl.t('plans.reactivation_highlights.tagging')],
      trialOptInHighlights: {
        featuresHeader: intl.t('authorization.sign_up_trial.starter.features_header'),
        includes: [intl.t('plans.card.social_set', {
          count: plan.numberOfSocialSets
        }), intl.t('shared_phrases.users.count', {
          count: plan.numberOfUsers
        })],
        keyFeatures: [intl.t('authorization.sign_up_trial.starter.list.stories_schedule'), intl.t('authorization.sign_up_trial.starter.list.reels_autopublish'), intl.t('authorization.sign_up_trial.starter.list.multi_autopublish'), intl.t('authorization.sign_up_trial.starter.list.bttp'), intl.t('authorization.sign_up_trial.starter.list.unlimited_hashtags', {
          count: plan.hasLimitedHashtagSearches ? plan.numberOfHashtagSearches : intl.t('plans.feature_mappings.unlimited')
        }), intl.t('authorization.sign_up_trial.starter.list.linkinbio'), intl.t('authorization.sign_up_trial.starter.list.analytics')],
        mobile: {
          includes: [intl.t('shared_phrases.social_sets.count', {
            count: plan.numberOfSocialSets
          }), intl.t('authorization.sign_up_trial.posts_per_month_unstyled', {
            count: plan.numberOfPosts
          }), intl.t('shared_phrases.users.count', {
            count: plan.numberOfUsers
          })]
        }
      },
      onboardingTrialOptInHighlights: {
        featuresHeader: intl.t('authorization.sign_up_trial.key_features'),
        keyFeatures: [intl.t('authorization.sign_up_trial.posts_per_month_unstyled', {
          count: plan.numberOfPosts
        }), intl.t('authorization.sign_up_trial.ai_credits_per_month', {
          count: plan.numberOfAiCredits
        }), intl.t('authorization.sign_up_trial.starter202506.key_features.analytics'), intl.t('authorization.sign_up_trial.linkinbio'), intl.t('authorization.sign_up_trial.basic_customer_support')],
        lostFeatures: [intl.t('onboarding.sourceless_trial.end_trial.what_you_lose.auto_publish'), intl.t('onboarding.sourceless_trial.end_trial.what_you_lose.bttp'), intl.t('onboarding.sourceless_trial.end_trial.what_you_lose.caption_writer'), intl.t('onboarding.sourceless_trial.end_trial.what_you_lose.hashtag')]
      }
    }),
    // eslint-disable-next-line @latermedia/later-linting/avoid-numerals-in-name
    growth202506: plan => ({
      highlights: [intl.t('plans.highlight_mappings.social_sets_extra', {
        count: plan.numberOfSocialSets,
        amount: locale.formatCurrency(plan.additionalSocialSetCosts.monthly.dollars)?.replace('.00', '')
      }), intl.t('plans.highlight_mappings.users_with_extra', {
        count: plan.numberOfUsers,
        amount: locale.formatCurrency(plan.additionalUserCosts.monthly.dollars)?.replace('.00', '')
      }), intl.t('plans.highlight_mappings.posts_per_month', {
        count: plan.numberOfPosts
      }), intl.t('shared_phrases.schedule_stories'), intl.t('shared_phrases.linkinbio_generic'), intl.t('plans.growth.highlights.highlight_6'), intl.t('shared_phrases.first_comment'), intl.t('plans.growth.highlights.highlight_8'), intl.t('shared_phrases.multi_photo_auto_publish'), intl.t('shared_phrases.instagram_product_tags')],
      autoTrialHighlights: {
        keyFeatures: [intl.t('authorization.sign_up_trial.posts_per_month_unstyled', {
          count: plan.numberOfPosts
        }), intl.t('plans.auto_trial.end_trial.full_analytics'), intl.t('plans.auto_trial.end_trial.custom_linkinbio'), intl.t('plans.auto_trial.end_trial.collab_tools'), intl.t('plans.auto_trial.end_trial.team_and_brand_management')]
      },
      migrationHighlights: [intl.t('shared_phrases.social_sets.count', {
        count: plan.numberOfSocialSets
      }), intl.t('plans.highlight_mappings.posts_per_profile', {
        count: plan.numberOfPosts
      }), intl.t('plans.highlight_mappings.users_with_extra', {
        count: plan.numberOfUsers,
        amount: locale.formatCurrency(plan.additionalUserCosts.monthly.dollars)?.replace('.00', '')
      })],
      reactivationHighlights: [intl.t('plans.reactivation_highlights.reels_autopublish'), intl.t('plans.reactivation_highlights.multi_photo_autopublish'), intl.t('plans.reactivation_highlights.stories_schedule'), intl.t('plans.highlight_mappings.bttp'), intl.t('plans.reactivation_highlights.more_analytics'), intl.t('plans.reactivation_highlights.team_management')],
      trialOptInHighlights: {
        featuresHeader: intl.t('authorization.sign_up_trial.growth.features_header'),
        includes: [intl.t('plans.card.social_set', {
          count: plan.numberOfSocialSets
        }), intl.t('shared_phrases.users.count', {
          count: plan.numberOfUsers
        })],
        keyFeatures: [intl.t('authorization.sign_up_trial.growth.list.analytics'), intl.t('authorization.sign_up_trial.growth.list.linkinbio'), intl.t('authorization.sign_up_trial.growth.list.instagram_tagging'), intl.t('authorization.sign_up_trial.growth.list.collect'), intl.t('authorization.sign_up_trial.growth.list.brand_management')],
        mobile: {
          includes: [intl.t('shared_phrases.social_sets.count', {
            count: plan.numberOfSocialSets
          }), intl.t('authorization.sign_up_trial.posts_per_month_unstyled', {
            count: plan.numberOfPosts
          }), intl.t('shared_phrases.users.count', {
            count: plan.numberOfUsers
          })]
        }
      },
      autoTrialActivationHighlights: {
        keyFeatures: [intl.t('shared_phrases.social_sets.count', {
          count: plan.numberOfSocialSets
        }), intl.t('shared_phrases.users.count', {
          count: plan.numberOfUsers
        }), intl.t('plans.feature_highlights.posts_per_month', {
          count: plan.numberOfPosts
        }), intl.t('plans.feature_highlights.analytics_trial_activation'), intl.t('plans.feature_highlights.reels'), intl.t('authorization.sign_up_trial.growth.list.instagram_tagging'), intl.t('account.downgrade.linkinbio_without_branding'), intl.t('plans.feature_highlights.instagram_and_tiktok')]
      },
      onboardingTrialOptInHighlights: {
        featuresHeader: intl.t('authorization.sign_up_trial.growth202506.features_header'),
        keyFeatures: [intl.t('authorization.sign_up_trial.social_inbox'), intl.t('authorization.sign_up_trial.external_approvals'), intl.t('authorization.sign_up_trial.posts_per_month_unstyled', {
          count: plan.numberOfPosts
        }), intl.t('authorization.sign_up_trial.ai_credits_per_month', {
          count: plan.numberOfAiCredits
        }), intl.t('authorization.sign_up_trial.growth202506.key_features.analytics'), intl.t('authorization.sign_up_trial.ugc_collection'), intl.t('authorization.sign_up_trial.custom_roles')],
        lostFeatures: [intl.t('onboarding.sourceless_trial.end_trial.what_you_lose.auto_publish'), intl.t('onboarding.sourceless_trial.end_trial.what_you_lose.bttp'), intl.t('onboarding.sourceless_trial.end_trial.what_you_lose.caption_writer'), intl.t('onboarding.sourceless_trial.end_trial.what_you_lose.hashtag')]
      },
      sourcelessTrialConfirmationHighlights: {
        keyFeatures: [{
          text: intl.t('onboarding.sourceless_trial.growth.auto_publish'),
          icon: 'instant'
        }, {
          text: intl.t('onboarding.sourceless_trial.growth.caption_writer'),
          icon: 'ai'
        }, {
          text: intl.t('onboarding.sourceless_trial.growth.ai_credits'),
          icon: 'credit'
        }, {
          text: intl.t('onboarding.sourceless_trial.growth.bttp'),
          icon: 'bttp'
        }]
      }
    }),
    // eslint-disable-next-line @latermedia/later-linting/avoid-numerals-in-name
    scale202506: plan => ({
      highlights: [intl.t('plans.highlight_mappings.social_sets_extra', {
        count: plan.numberOfSocialSets,
        amount: locale.formatCurrency(plan.additionalSocialSetCosts.monthly.dollars)?.replace('.00', '')
      }), intl.t('plans.highlight_mappings.users_with_extra', {
        count: plan.numberOfUsers,
        amount: locale.formatCurrency(plan.additionalUserCosts.monthly.dollars)?.replace('.00', '')
      }), intl.t('shared_phrases.unlimited_posts'), intl.t('shared_phrases.schedule_stories'), intl.t('shared_phrases.linkinbio_generic'), intl.t('plans.scale202506.highlights.highlight_6'), intl.t('shared_phrases.first_comment'), intl.t('plans.scale202506.highlights.highlight_8')],
      migrationHighlights: [intl.t('plans.scale202506.highlights.highlight_1'), intl.t('shared_phrases.unlimited_posts'), intl.t('plans.highlight_mappings.users_with_extra', {
        count: plan.numberOfUsers,
        amount: locale.formatCurrency(plan.additionalUserCosts.monthly.dollars)?.replace('.00', '')
      })],
      reactivationHighlights: [intl.t('plans.reactivation_highlights.reels_autopublish'), intl.t('plans.reactivation_highlights.multi_photo_autopublish'), intl.t('plans.reactivation_highlights.stories_schedule'), intl.t('plans.highlight_mappings.bttp'), intl.t('plans.reactivation_highlights.more_analytics'), intl.t('plans.reactivation_highlights.team_management')],
      trialOptInHighlights: {
        featuresHeader: intl.t('authorization.sign_up_trial.advanced.features_header'),
        includes: [intl.t('plans.card.social_set', {
          count: plan.numberOfSocialSets
        }), intl.t('shared_phrases.users.count', {
          count: plan.numberOfUsers
        })],
        keyFeatures: [intl.t('authorization.sign_up_trial.scale202506.list.live_chat')]
      },
      onboardingTrialOptInHighlights: {
        featuresHeader: intl.t('authorization.sign_up_trial.scale202506.features_header'),
        keyFeatures: [intl.t('authorization.sign_up_trial.scale202506.key_features.custom_analytics'), intl.t('authorization.sign_up_trial.competitive_benchmarking'), intl.t('authorization.sign_up_trial.future_insights'), intl.t('authorization.sign_up_trial.scale202506.unlimited_posts'), intl.t('authorization.sign_up_trial.ai_credits_per_month', {
          count: plan.numberOfAiCredits
        }), intl.t('authorization.sign_up_trial.scale202506.key_features.analytics'), intl.t('authorization.sign_up_trial.priority_support')]
      }
    })
  });
  var _default = _exports.default = highlightsMap;
});